<template>
    <div :class="$style.wrapper">
        <div :class="$style.header">
            <span>订单号：<span :class="$style.black">{{order.order_sn}}</span></span>
            <span :class="$style.divider">|</span>
            <span>{{order.order_time}}</span>
            <span :class="$style.divider">|</span>
            <span v-if="order.pay_all==''">{{order.payname}}</span>
            <span v-else-if="order.pay_all!=''" v-for="item in order.pay_all">{{item.pay_name}}:{{item.order_amounts}}元</span>
            <span :class="$style.divider">|</span>
            <span>收货人：{{order.consignee}}</span>
            <span :class="$style.divider">|</span>
            <span>vip卡号:{{order.single_number}}</span>
            <span :class="$style.divider">|</span>
            <span>合同订单号:{{order.contract_number}}</span>
            <span :class="$style.divider">|</span>
            <span v-show="order.referer === '门店'">促销员电话:{{order.sale_mobile}}</span>
        </div>
        <div :class="$style.content">
            <div style="width: 40%">
                <div :class="$style.orderInfo"
                     :key="rec_id"
                     v-for="{rec_id, goods_name, goods_attr, goods_img,referer,order_id, goods_number, goods_price,goods_id, goods_attr_id, goods_attr_list,goods_attr_select,  product_id} in order.goods_list">
                    <div style="width: 72%">
                        <img :src="host + '/' + goods_img" alt="">
                        <span style="text-align: left; word-break: break-all;">
                                       型号:{{goods_attr_select[0]}}
                            <!--<pre style="color: gray;font-size: 12px;margin: 0; line-height: 1.5">{{goods_attr}}</pre>-->
                        </span>
                    </div>
                    <span style="width: 15%; text-align: center">￥{{goods_price}}</span>
                    <span style="width: 10%; text-align: center">{{goods_number}}</span>
                    <div>
                        <Confirm
                            :handleConfirm="()=>deleteOrder(order.goods_list,rec_id)" :loading="btnLoading">
                            <el-button size="small" type="danger" icon="el-icon-delete">删除</el-button>
                        </Confirm>
                        &nbsp;&nbsp;
                        <Dialogsa
                            :goods_attr_list="goods_attr_list"
                            :goods_attr_id="goods_attr_id"
                            :goods_id="goods_id"
                            :rec_id="rec_id"
                            :product_id="product_id"
                            :referer="referer"
                            :goods_price="goods_price"
                            :order_id="order_id"
                            :goods_number="goods_number"
                            :getCartProducts="getCartProducts"
                            :getOrderList="getOrderList"
                        >
                            <el-button  type="warning" icon="el-icon-edit" size="small"
                            >修改商品
                            </el-button>
                        </Dialogsa>
                    </div>
                </div>
                <div :class="$style.orderInfo" v-if="order.status!==3">
                    <el-button  style="margin-left: 35%" type="primary" icon="el-icon-circle-plus-outline" size="small" @click="addorder(order.order_id)">添加商品</el-button>
                </div>

                <!--<p class="points" v-if="order.status!==3"-->
                   <!--&gt;添加商品</p>-->
            </div>
            <div :class="$style.payPrice">
                <span>{{order.goods_amount}}</span>
                <p>{{order.xiadanname}}</p>
            </div>
            <div :class="$style.status">
                <span v-if="order.status === 0">等待付款</span>
                <span v-else-if="order.status === 1">取消</span>
                <span v-else-if="order.status === 2">待发货</span>
                <span v-else-if="order.status === 3">已发货</span>
                <span v-else-if="order.status === 4">交易成功</span>
                <span v-else-if="order.status === 5">已申请退货</span>
                <el-popover
                    ref="popover1"
                    placement="bottom"
                    width="150"
                    trigger="hover"
                >
                    <div>
                        <div
                            v-for="({content, time}, index) in order.track"
                            :key="index"
                            style="display: flex; align-items: flex-start; font-size: 12px; margin-bottom: 5px">
                            <span class="point"/>
                            <div style="display: flex; flex-direction: column;">
                                <span>{{content}}</span>
                                <span>{{time}}</span>
                            </div>
                        </div>
                    </div>
                </el-popover>
            </div>
            <div :class="$style.action">
                <el-button v-if="order.status ===0" style=""
                           @click="querenOrder(order.order_id)">设置为已支付
                </el-button>
                <el-button v-else-if="order.status ===2||order.status ===1" style="background:#f3701e;"
                           @click="quxiaoOrder(order.order_id)">设置为未支付
                </el-button>
                <!--<el-button v-else-if="order.status ===0&&order.is_upload===0" @click="open(order.order_id)">上传凭证-->
                <!--</el-button>-->
                <!--<p :class="$style.wait" v-else-if="order.status===0&&order.is_upload===2">正在审核</p>-->
                <!--<el-button  v-else-if="order.status ===2&&order.is_yuyue===0"  style="background: #F56C31" @click="OrderAdd(order)">预约安装</el-button>-->
                <!--<el-button disabled style="background: #BDBABA" v-else-if="order.status ===2&&order.is_yuyue===1">-->
                    <!--已预约安装-->
                <!--</el-button>-->
                <p v-else-if="order.status ===3||order.status ===5" :class="$style.wait">待确认</p>
                <p v-if="order.status === 0 ">
                    <PayStyleDialog :order="order" :update="getOrderList"><span>修改支付方式</span></PayStyleDialog>
                </p>
                <!--<p v-if="Auth.lookOrder==true">-->
                <p>
                    <span
                        @click="OrderDetail(order)">订单详情</span></p>
                <Confirm  :handleConfirm="cancelOrder" :loading="btnLoading" v-if="order.status!==1">
                    <p style="display: inline"><span>取消订单</span></p>
                </Confirm>
                <Confirm  :handleConfirm="()=>deleteOrders(order.order_sn)" :loading="btnLoading" v-if="order.status===1">
                    <p style="display: inline"><span>移除订单</span></p>
                </Confirm>
                <!-- <p  v-if="order.status === 0&&in_array(orderAuth,'payOderr')=='true'" style="display: inline" @click="removes(order)"><span>取消</span></p> -->
                <!--status=4交易成功和status=1交易关闭显示 删除按钮-->

                <Confirm v-if="order.status === 0" :handleConfirm="()=>deleteOrder(order.goods_list,rec_id)"
                         :loading="btnLoading">
                    <!-- <p style="display: inline"><span>删除</span></p> -->
                </Confirm>

                <p v-if="order.is_upload===1"><span
                    @click="checkimg(order)">查看支付凭证</span></p>
                <p v-if="order.referer==='门店'||order.referer==='扫码'">
                    <span
                    @click="changeContractNumber(order)">修改合同订单号</span></p>
                <p v-if="order.status ===0&&order.payname=='线下付款'&&order.referer!='供应链'">
                    <span @click="confirm(order)">确认付款</span></p>
                <p ><a style="text-decoration:none;color:#9ca2ad;"
                                              target="_blank"
                                              :href="$reqUrl + 'admin/order.php?act=info&order_id='+order.order_id+'&print='+1"
                                              class="points">打印合同</a></p>
            </div>
        </div>
        <el-dialog title="订单分配" :visible.sync="ShowDistribution" width="1000px">
            <div class="dialog-left">
                <el-table
                    ref="multipleTable"
                    :data="OrderFenpei"
                    tooltip-effect="dark"
                    style="width: 100%;font-size: 12px"
                    @selection-change="handleSelectionChange">
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column label="商品" prop="goods_attr" align="center" width="250"></el-table-column>
                    <el-table-column label="购买" prop="goods_number" align="center"></el-table-column>
                    <el-table-column label="已分配" prop="yuyue_number" align="center"></el-table-column>
                    <el-table-column label="分配"  align="center">
                        <template slot-scope="props">
                            <el-input-number v-model="props.row.fpnum" controls-position="right" :min="1" :max="props.row.goods_number-+props.row.yuyue_number" @change="handleChange"  size="small" style="width: 80px"></el-input-number>
                            <!--{{props.row.goods_number-props.row.yuyue_number}}-->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="dialog-right">
                <el-form :model="form">
                    <el-form-item label="客户姓名:" :label-width="formLabelWidth">
                        <el-input v-model="form.consignee" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话:" :label-width="formLabelWidth">
                        <el-input v-model="form.mobile" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="送货方式:" :label-width="formLabelWidth">
                        <el-select v-model="formData.goodsSelect" placeholder="请选择送货方式" style="width: 290px" @change="isSongZhuang">
                            <el-option
                                v-for="item in passSelect"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="安装时间:" :label-width="formLabelWidth" v-show="formData.goodsSelect===3">
                        <el-date-picker
                            v-model="formData.azTime"
                            @change="consl"
                            type="date"
                            placeholder="选择安装日期"
                            :picker-options="pickerOptions0" style="width: 290px"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="安装公司:" :label-width="formLabelWidth" v-show="formData.goodsSelect===3">
                        <el-select v-model="formData.company_id" placeholder="公司名称" @change="selectname(formData.company_id)" style="width: 290px">
                            <el-option v-for="item in selectCompany" :label="item.company_name" :value="item.company_id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="物流公司:" :label-width="formLabelWidth" v-show="formData.goodsSelect===1">
                        <el-select v-model="formData.wuliu_id" placeholder="物流公司名称" @change="selectwuliuu(formData.wuliu_id)" style="width: 290px">
                            <el-option v-for="item in selectWuliu" :label="item.name" :value="item.id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="送货司机:" :label-width="formLabelWidth" v-show="formData.goodsSelect===0">
                        <el-select v-model="formData.siji_id" placeholder="送货司机名称" @change="selectsiji(formData.siji_id)" style="width: 290px">
                            <el-option v-for="item in selectSonghuo" :label="item.siji_name" :value="item.id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="送货地址:" :label-width="formLabelWidth">
                        <div v-show="changeAddress == false"><span style="float: left">{{form.address_detail}}</span><el-button type="primary" @click="isChangeAddr" >修改地址</el-button></div>
                        <div v-if="changeAddress == true">
                            <el-select v-model="formData.province" placeholder="省份" style="width: 90px">
                                <el-option
                                    v-for="{region_id, region_name} in provinceList"
                                    :key="region_id"
                                    :value="region_id"
                                    :label="region_name"
                                >
                                </el-option>
                            </el-select>
                            <el-select v-model="formData.city" placeholder="城市" style="width: 90px">
                                <el-option
                                    v-for="{region_id, region_name} in cityList"
                                    :key="region_id"
                                    :value="region_id"
                                    :label="region_name"
                                ></el-option>
                            </el-select>
                            <el-select v-model="formData.district" placeholder="区" style="width: 90px">
                                <el-option
                                    v-for="{region_id, region_name} in districtList"
                                    :key="region_id"
                                    :value="region_id"
                                    :label="region_name"
                                ></el-option>
                            </el-select>
                            <el-input :rows="3" type="textarea" placeholder="详细地址信息" v-model="formData.address" style="margin-top: 15px"></el-input>
                            <!--<a @click="SureChangeAddr">确认修改</a><a>　|　</a>-->
                            <a @click="FalseChangeAddr">取消修改</a>
                        </div>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="queren">提交</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="查看凭证" :visible.sync="outerVisible" align="center" width="700">
            <el-dialog
                width="500"
                title="凭证"
                align="center"
                :visible.sync="innerVisible"
                append-to-body>
                <a :href="host+pzimg" target="_blank"><img :src="host+pzimg" style="width: 500px;" :style="{transform:'rotate('+rotate+'deg)'}"></a>
                <img src="../../assets/左转-01.png" @click="turnLeft" style="margin-right: 40px">
                <img src="../../assets/右转-01.png" @click="turnRight">
            </el-dialog>
            <img :src="host+item" v-for="item in order.payimg" style="width: 150px;display: inline-block;margin-left: 20px;cursor: pointer" @click="imgLook(item)">
            <div slot="footer" class="dialog-footer">
                <el-button @click="outerVisible = false">关 闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改合同订单号" :visible.sync="changeOrderNumber" width="500px">
            <el-form :model="changeForm" style="margin-top: 30px;padding: 0 30px">
                <el-form-item label="合同订单号:" :label-width="formLabelWidth">
                    <el-input v-model="changeForm.contract_number"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button type="primary" @click="ChangeConOrder" :loading="isbtnload">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        host,
        cancelOrder,
        getAppointment,
        deleteOrder,
        postAppointment,
        session_id,
        getCartProducts,
        getUserInfo,
        getAddressSelect,
        getInstallCompany,
        deleteOrders
    } from '../../stores/api';
    import PayStyleDialog from '../Common/PayStyleDialog.vue';
    import AddressDialog from '../Common/AddressDialog.vue';
    import Confirm from '../Common/Confirm.vue';
    import Vue from 'vue';
    import { mapState } from 'vuex';
    import Dialogs from './Dialogs.vue';
    import ElRow from "element-ui/packages/row/src/row";
    import ElCol from "element-ui/packages/col/src/col";

    Vue.component('Dialogsa', Dialogs);
    Vue.component('PayStyleDialog', PayStyleDialog);
    Vue.component('AddressDialog', AddressDialog);
    Vue.component('Confirm', Confirm);
    export default {
        components: {
            ElCol,
            ElRow},
        props: ['order', 'getOrderList', 'temp', 'isDetail'],
        data() {
            return {
                outerVisible: false,
                innerVisible: false,
                changeOrderNumber: false,
                rotate: 0,
                pzimg: '',
                value1: '',
                yytime: '',
                ordlist: [],
                ordlist1: [],
                changeForm: {contract_number: '', order_id:''}, //修改合同订单号
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                host: host,
                cancelVisible: false,
                btnLoading: false,
                addressData: null,
                appointmentData: [],
                currAppointment: '',
                orderAuth: '',
                referer:'',
                Auth:{
                    payOrder:false,
                    addOrderGoods:false,
                    editPay:false,
                    lookOrder:false,
                    print:false,
                    cancelOrder:false,
                    editOrderGoods:false,
                    lirun:false
                },
                hrefs: '',
                delivery_method: '',
                orderlt: [],
                options: [{value: 0, label: '送货'},
                    {value: 1, label: '物流'},
                    {value: 2, label: '自提'},
                    {value: 3, label: '送装'},
                    {value: 4, label: '快递'},
                    {value: 5, label: '直发'},
                    {value: 6, label: '其他'}
                ],
                ShowDistribution: false,
                OrderFenpei: [],
                OrderSelect: [], //分配的订单数组
                formLabelWidth: '100px',
                form: {},
                changeAddress: false, //是否修改地址
                passSelect: [{value: 0, label: '送货'},
                    {value: 1, label: '物流'},
                    {value: 2, label: '自提'},
                    {value: 3, label: '送装'},
                    {value: 4, label: '快递'},
                    {value: 5, label: '直发'},
                    {value: 6, label: '其他'}
                ],
                formData: {//填写配送信息
                    goodsSelect: '', //配送方式
                    azTime: '',
                    yytime: '', //安装时间
                    company_id: '',
                    company_name: '',
                    siji_id: '',
                    siji_name: '',
                    wuliu_id: '',
                    wuliu_name: '',

                    province: '', //省
                    city: '', //市
                    district: '', //区
                    address: '', //详细地址
                },
                selectCompany: [],
                selectWuliu: [],
                selectSonghuo: [],
                page: 1,
                pickerOptions0: {//限制安装时间只能是当天或之后
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                }
            };
        },
        created() {
            this.getqx()

            console.log('temp'+ JSON.stringify(this.temp));
            // this.getordList()
        },
        watch: {
            'formData.province': async function (val, oldVal) {
                const data = await this.getCityList(val);
                if (data.length > 0) {
                    this.formData.city = data[0].region_id;
                }
            },
            'formData.city': async function (val, oldVal) {
                const data = await this.getDistrictList(val);
                if (data.length > 0) {
                    this.formData.district = data[0].region_id;
                }
            },
            async visible (val) {
                if (val) {
                    if (this.type === 1) {
                        this.getCityList(this.formData.province);
                        this.getDistrictList(this.formData.city);
                    } else {
                        const provinces = await this.getCityList(this.provinceList[0].region_id);
                        const districts = await this.getDistrictList(provinces[0].region_id);
                        this.formData.province = this.provinceList[0].region_id;
                        this.formData.city = provinces[0].region_id;
                        this.formData.district = districts[0].region_id;
                    }
                }
            },
            editData (val) {
                if (this.type === 3) {
                    const {province_checked_id, city_checked_id, district_checked_id, ...rest} = val;
                    this.formData = {
                        province: province_checked_id,
                        city: city_checked_id,
                        district: district_checked_id,
                        ...rest
                    };
                } else {
                    this.formData = {...val};
                }
            }
        },
        computed: {
            ...mapState(['provinceList']),
        },
        methods: {
            getordList () {
                this.ordlist = []
                this.ordlist1 = []
                this.order.goods_list.forEach(item => {
                    if (item.yuyue_number !== item.goods_number) {
                        this.ordlist.push(item.goods_name)
                    }
                })
                this.order.goods_list.forEach(item => {
                    if (item.yuyue_number !== item.goods_number) {
                        this.ordlist1.push(item.goods_name)
                    }
                })
                this.checkChange()
            },
            checkChange() {
                if (this.ordlist.length !== 0) {
                    this.orderlt = []
                    this.ordlist.forEach(item => {
                        this.order.goods_list.forEach(i => {
                            if (item === i.goods_name && i.yuyue_number !== i.goods_number) {
                                this.orderlt.push({'name': i.goods_name, 'num': i.goods_number, 'rec_id': i.rec_id, 'max': +i.goods_number - +i.yuyue_number})
                            }
                        })
                    })
                    console.log(this.orderlt)
                } else{
                    this.$message.warning('至少选择一种产品')
                }
            },
            consl () {
                this.yytime = Date.parse(this.value1.toLocaleDateString()).toString().slice(0, 10)
                console.log(this.yytime)
            },
            //订单详情
            OrderDetail(order) {
                localStorage.setItem('temp', JSON.stringify(this.temp))
                localStorage.setItem('isDetail', this.isDetail)
                this.$router.push('/OrderList/' + order.order_sn)
            },
            //取消订单
            cancelOrder() {
                this.btnLoading = true;
                cancelOrder(this.order.order_sn).then(() => {
                    this.$notify.success({
                        title: '操作成功',
                        message: '该订单已关闭',
                    });
                    this.cancelVisible = false;
                    this.order.status = 1;
                }).catch(err => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                }).then(() => {
                    this.btnLoading = false;
                });
            },
            //移除订单
            deleteOrders (order_sn) {
                deleteOrders(order_sn).then(res => {
                    if (res.data.error === 0) {
                        this.$notify.success({
                            title: '操作成功',
                            message: '该订单已移除',
                        });
                        this.getOrderList()
                    }
                })
            },
            deleteOrder(order, rec_id) {
                this.btnLoading = true;
                console.log(order);
                deleteOrder(order, rec_id).then((res) => {
                    this.$notify.success({
                        title: '操作成功',
                        message: '该订单已删除',
                    });
                    this.cancelVisible = false;
                    this.visible = false;
                    this.getOrderList();
                }).catch(err => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                }).then(() => {
                    this.btnLoading = false;
                });
            },
            getAppointment(order_sn) {
                this.getordList()
                getAppointment(order_sn).then(res => {
                    this.addressData = res.data.addres_data;
                    this.appointmentData = res.data.yuyue_data;
                    for (let i = 0, len = res.data.yuyue_data.length; i < len; i++) {
                        if (res.data.yuyue_data[i].remaining > 0) {
                            this.currAppointment = res.data.yuyue_data[i].time;
                            break;
                        }
                    }
                });
            },
            handleSelectAppointment(time) {
                if (this.currAppointment !== time) {
                    this.currAppointment = time;
                }
            },
            open(id) {
                window.open(host + '/flow.php?step=order_pay&id=' + id);
            },
            //设置为支付
            querenOrder (id) {
                this.$alert('是否确认该订单', '确认订单', {
                    confirmButtonText: '确定',
                }).then(() => {
                    this.$http.get(this.$reqUrl + `user.php?act=mendian_confirm&session_id=${localStorage.getItem('shouhou_session_id')}&order_id=${id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                        } else if (res.data.error === 1) {
                            this.$message.error(res.data.msg)
                        }
                        this.getOrderList()
                    }).catch(err => {
                        console.log(err)
                    })
                })
            },
            //设置为未支付
            quxiaoOrder (id) {
                this.$alert('是否设置该订单为未支付', '设置订单', {
                    confirmButtonText: '确定',
                }).then(() => {
                    this.$http.get(this.$reqUrl + `user.php?act=change_order_to_unpay&session_id=${localStorage.getItem('shouhou_session_id')}&order_id=${id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                        } else if (res.data.error === 1) {
                            this.$message.error(res.data.msg)
                        }
                        this.getOrderList()
                    }).catch(err => {
                        console.log(err)
                    })
                })
            },
            //查看凭证
            checkimg(order) {
                // window.open(host + order.payimg);
                this.outerVisible = true
            },
            changeContractNumber (row) {
                this.changeOrderNumber = true
                this.changeForm.contract_number = row.contract_number
                this.changeForm.order_id = row.order_id
            },
            ChangeConOrder() {
                if (this.changeForm.contract_number === '') {
                    this.$message.error('合同订单号不能为空')
                } else {
                    let data = {
                        'session_id': localStorage.getItem('shouhou_session_id'),
                        'order_id': this.changeForm.order_id,
                        contract_number: this.changeForm.contract_number
                    }
                    this.$http.get(this.$reqUrl + 'user.php?act=update_order_address', {params: data}).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('修改成功')
                            this.changeOrderNumber = false
                            this.getOrderList()
                        }
                    })
                }
            },
            imgLook(item) {
                this.pzimg = item
                this.rotate = 0
                this.innerVisible = true
            },
            turnLeft() {
                this.rotate -= 90
            },
            turnRight() {
                this.rotate += 90
            },
            //确认付款
            confirm(order) {
                this.$confirm('确认支付, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.get(this.$reqUrl + 'user.php?act=order_confirmPay&session_id=' + session_id + '&order_id=' + order.order_id)
                        .then((res) => {
                            console.log(res);
                            this.$router.go('/OrderList')
                            this.$message({
                                type: 'success',
                                message: '成功支付!'
                            });
                        })
                        .catch((res) => {
                            console.log(res)
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消支付',
                    })
                });
            },
            //取消订单
            removes(order) {
                this.$confirm('确认取消订单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.get(this.$reqUrl + 'user.php?act=cancel_order&session_id=' + session_id + '&order_id=' + order.order_id)
                        .then((res) => {
                            this.$router.go('/OrderList')
                            this.$message({
                                type: 'success',
                                message: '成功取消订单!'
                            });
                        })
                        .catch((res) => {
                            // console.log(res)
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作',
                    });
                });
            },
            //添加商品
            addorder(order, goods_id) {
                localStorage.setItem('order_id', order);
                this.$router.push('/SupplyChain/AddProduct');
            },
            in_array(element, a) {
                // console.log(JSON.parse(sessionStorage.getItem('orderAuth')))
                // console.log(element)
                for (var i = 0; i < element.length; i++) {
                    if (element[i] === a) {
                        // console.log("sss")
                        return true;
                    }
                }
                return false;
            },
            //权限设置
            //
            getqx() {
                getUserInfo().then(res => {
                    // console.log(res)
                    // this.orderAuth = res.data.userinfo.orderAuth.split(",");
                    // sessionStorage.setItem('orderAuth',JSON.stringify(this.orderAuth))
                    // console.log(this.orderAuth)
                    // this.orderAuth.forEach((item,i)=>{
                    //     if(item==='payOrder'){
                    //         // console.log('ss')
                    //         this.Auth.payOrder=true
                    //     }
                    //     if(item==='addOrderGoods'){
                    //         this.Auth.addOrderGoods=true
                    //     }
                    //     if(item==='editPay'){
                    //         this.Auth.editPay=true
                    //     }
                    //     if(item==='lookOrder'){
                    //         this.Auth.lookOrder=true
                    //     }
                    //     if(item==='print'){
                    //         this.Auth.print=true
                    //     }
                    //     if(item==='cancelOrder'){
                    //         this.Auth.cancelOrder=true
                    //     }
                    //     if(item==='editOrderGoods'){
                    //         this.Auth.editOrderGoods=true
                    //     }
                    //     if(item==='lirun'){
                    //         this.Auth.lirun=true
                    //     }
                    // })
                    // console.log(this.Auth);
                    // function in_array(element, a) {
                    //     // console.log(element)
                    //     for (var i = 0; i < element.length; i++) {
                    //         if (element[i] === a) {
                    //             console.log("sss")
                    //             return true;
                    //         }
                    //     }
                    //     return false;
                    // }
                    // console.log(in_array(this.orderAuth, 'payOrder'))
                })
            },


            //预约安装弹出框
            async getCityList (id) {
                return getAddressSelect(id).then((res) => {
                    this.cityList = res.data;
                    return res.data;
                });
            },
            async getDistrictList (id) {
                return getAddressSelect(id).then(res => {
                    this.districtList = res.data;
                    return res.data;
                });
            },
            OrderAdd(row) { //弹出框数据赋值
                this.ShowDistribution = true
                this.OrderFenpei = []
                row.goods_list.forEach((item, i) => {
                    if (+item.goods_number - +item.yuyue_number !== 0) {
                        this.OrderFenpei.push(item)
                    }
                    // this.OrderFenpei[i]['max'] = +item.goods_number - +item.yuyue_number
                    // this.OrderFenpei[i]['fpnum'] = +item.goods_number - +item.yuyue_number
                    // if (+item.goods_number - +item.yuyue_number === 0) {}
                })
                // this.OrderFenpei.forEach((item, i) => {
                //     console.log(this.orderFenpei[i].goods_number);
                //     // if (+item.goods_number-+item.yuyue_number ===0){
                //     //     item
                //     // }
                // })
                console.log(this.OrderFenpei)
                this.form = row
                this.form['time'] = ''
            },
            handleChange() {
                console.log(this.OrderFenpei)
            },
            //判断配送方式
            isSongZhuang() {
                if (this.formData.goodsSelect !== 3) { //非送装
                    this.formData.azTime = ''
                    this.formData.company_id = ''
                    this.formData.company_name = ''
                } else if (this.formData.goodsSelect === 3) { //送装
                    this.page = 1;
                    getInstallCompany(this.page).then(res => {
                        this.selectCompany = []
                        this.selectCompany = res.data.company_list
                        this.page_count = res.data.page_count
                        if (this.page_count > 1) {
                            this.page = 2;
                            for (var i = 0; i < this.page_count - 1; i++) {
                                this.page += i;
                                getInstallCompany(this.page).then(res => {
                                    res.data.company_list.forEach(item => {
                                        this.selectCompany.push(item)
                                    })
                                })
                            }
                            // console.log(this.selectCompany)
                        }
                    })
                }
                if (this.formData.goodsSelect !== 1) {
                    this.formData.wuliu_id = ''
                    this.formData.wuliu_name = ''
                } else if (this.formData.goodsSelect === 1) {
                    this.page = 1;
                    this.$http.get(this.$reqUrl + `service.php?act=wuliu_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                        this.selectWuliu = []
                        this.selectWuliu = res.data.data
                        this.page_count = res.data.page_count
                        console.log(this.selectWuliu)
                        if (this.page_count > 1) {
                            this.page = 2;
                            for (var i = 0; i < this.page_count - 1; i++) {
                                this.page += i;
                                this.$http.get(this.$reqUrl + `service.php?act=wuliu_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                                    res.data.data.forEach(item => {
                                        this.selectWuliu.push(item)
                                    })
                                })
                            }
                        }
                    })
                }
                if (this.formData.goodsSelect !== 0) {
                    this.formData.siji_name = ''
                    this.formData.siji_id = ''
                } else if (this.formData.goodsSelect === 0) {
                    this.page = 1;
                    this.$http.get(this.$reqUrl + `service.php?act=siji_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                        this.selectSonghuo = []
                        this.selectSonghuo = res.data.data
                        this.page_count = res.data.page_count
                        console.log(this.selectSonghuo)
                        if (this.page_count > 1) {
                            this.page = 2;
                            for (var i = 0; i < this.page_count - 1; i++) {
                                this.page += i;
                                this.$http.get(this.$reqUrl + `service.php?act=siji_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                                    res.data.data.forEach(item => {
                                        this.selectSonghuo.push(item)
                                    })
                                })
                            }
                        }
                    })
                }
            },
            selectname(id) { //根据所选安装公司id判断安装公司
                this.selectCompany.forEach((item, i) => {
                    if (id === item.company_id) {
                        this.formData.company_name = item.company_name
                    }
                })
                // console.log(this.formData)
            },
            selectwuliuu(id) { //根据所选物流公司id判断物流公司
                this.selectWuliu.forEach((item, i) => {
                    // console.log(id, item.id)
                    if (id === item.id) {
                        this.formData.wuliu_name = item.name
                    }
                })
                // console.log(this.formData.wuliu_name)
            },
            selectsiji(id) { //根据所选司机id判断司机名
                this.selectSonghuo.forEach((item, i) => {
                    // console.log(item.id)
                    if (id === item.id) {
                        this.formData.siji_name = item.siji_name
                    }
                })
                // console.log(this.formData.siji_name)
            },
            consl () { //日期转时间戳
                this.formData.yytime = Date.parse(this.formData.azTime.toLocaleDateString()).toString().slice(0, 10)
                console.log(this.formData.yytime)
            },
            handleSelectionChange(val) {
                this.OrderSelect = val;
                console.log(this.OrderSelect)
            },
            isChangeAddr() { //修改地址
                this.changeAddress = true
            },
            // SureChangeAddr() { //确认修改
            //     this.changeAddress = false
            // },
            FalseChangeAddr() { //取消修改
                this.changeAddress = false
                this.formData.province = this.form.province
                this.formData.city = this.form.city
                this.formData.district = this.form.district
                this.formData.address = this.form.address
                console.log(this.formData);
            },
            //提交分配
            queren() {
                if (this.OrderSelect.length === 0) {
                    this.$message.error('请选择配送商品')
                } else {
                    let rec_ids = []
                    let numbers = []
                    if (this.changeAddress === false) {
                        this.formData.province = this.form.province
                        this.formData.city = this.form.city
                        this.formData.district = this.form.district
                    }
                    this.OrderSelect.forEach(item => {
                        rec_ids.push(item.rec_id)
                        numbers.push(item.fpnum)
                    })
                    var datas = {
                        city_checked_id: this.formData.city,
                        district_checked_id: this.formData.district,
                        province_checked_id: this.formData.province,
                        address: this.formData.address,
                        mobile: this.form.mobile,
                        consignee: this.form.consignee,
                        order_sn: this.form.order_sn,
                        yuyue_time: this.formData.yytime,
                        rec_ids: rec_ids, //rec_id数组
                        numbers: numbers, //商品数量数组
                        delivery_method: this.formData.goodsSelect,
                        order_id: this.form.order_id,
                        company_id: this.formData.company_id,
                        company_name: this.formData.company_name,
                        wuliu_id: this.formData.wuliu_id,
                        wuliu_name: this.formData.wuliu_name,
                        siji_id: this.formData.siji_id,
                        siji_name: this.formData.siji_name
                    }
                    console.log(datas)
                    // this.$http.post(this.$reqUrl + `user.php?act=post_orders_yuyue&session_id=${session_id}`, qs.stringify(datas)).then(res => {
                    //     // if (res.data.error === 0) {
                    //     this.$message.success(res.data.msg)
                    //     // this.getOrderList()
                    //     this.ShowDistribution = false
                    //     // }
                    // })
                    postAppointment(datas).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.content)
                            this.getOrderList({page: this.page})
                            this.ShowDistribution = false
                        }
                    })
                }
            }

        },
    };
</script>
<style lang="less" module>
    .wrapper {
        margin-bottom: 15px;
        border: 1px solid #d8dde6;
        .header {
            padding: 0 20px;
            display: flex;
            position: relative;
            background: #f0f5fc;
            height: 43px;
            line-height: 43px;
            font-size: 14px;
            color: #9ca2ad;
            .divider {
                margin: 0 8px;
            }
            .black {
                color: #1f2329;
            }
        }
        .content {
            display: flex;
            color: #1f2329;
            .orderInfo {
                text-align: right;
                width: 100%;
                padding: 20px;
                padding-right: 0;
                display: flex;
                border-top: 1px solid #d8dde6;
                border-right: 1px solid #d8dde6;
                & > div {
                    display: flex;
                    img {
                        width: 99px;
                        height: 99px;
                        margin-right: 5px;
                        border: 1px solid #dee0e0;
                    }
                }
            }
            .payPrice {
                width: 20%;
                padding-top: 20px;
                text-align: center;
                border-top: 1px solid #d8dde6;
                border-right: 1px solid #d8dde6;
                p {
                    margin-top: 40px;
                    margin-bottom: 0;
                    color: #9ca2ad;
                }
            }
            .status {
                width: 20%;
                padding-top: 20px;
                text-align: center;
                border-top: 1px solid #d8dde6;
                border-right: 1px solid #d8dde6;
                p {
                    margin-top: 10px;
                    margin-bottom: 0;
                    color: #9ca2ad;
                }
            }
            .action {
                width: 20%;
                padding-top: 20px;
                text-align: center;
                border-top: 1px solid #d8dde6;
                button {
                    background: #f74845;
                    border-radius: 4px;
                    min-width: 100px;
                    height: 28px;
                    padding: 0;
                    font-size: 14px;
                    color: #FFF;
                    border: 0;
                }
                p {
                    margin: 5px 0;
                    color: #9ca2ad;
                    span {
                        cursor: pointer;
                        &:hover {
                            color: dodgerblue;
                        }
                    }
                }
                .wait {
                    color: #000;
                    font-size: 18px;
                }
            }
        }
    }
</style>
<style>
    .dialog-left{
        width: 50%;
        margin: 20px 15px;
        height: auto;
        text-align: center;
        border: 1px solid #f56c31;
        float: left;

    }
    .el-input--suffix .el-input__inner{
        padding-right: 30px;
    }
    .dialog-right{
        width:36% ;
        margin: 20px 15px;
        float: right;
        text-align: center;
    }
    .point {
        width: 8Px;
        height: 8Px;
        border-radius: 50%;
        background: rgb(247, 72, 69);
        margin: 5Px;
    }

    .points:hover {
        color: dodgerblue !important;
        cursor: pointer;
    }

    .addsp {
        right: 30px;
        top: 6px;
        position: absolute;
    }
</style>




// WEBPACK FOOTER //
// src/components/OrderList/Order.vue